import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';
import { useDLocalPermanentPaymentMethod } from 'src/app/shared/hooks/payments';

import { useMembershipModalState } from '../../modalContext';

import { useBraintreePermanentPaymentMethod } from './useBraintreePermanentPaymentMethod';
import { useStripePermanentPaymentMethod } from './useStripePermanentPaymentMethod';

// eslint-disable-next-line max-lines-per-function
export function usePreparePaymentMethod(): (token?: string) => Promise<void> {
	const countryCode = useCountryCode();
	const locale = useLocale();

	const [
		{
			gateway,
			tokenizationData,
			email,
			usingSavedPaymentMethod,
			paymentType,
			currencyCode,
			savingBraintreePaymentTemporarilyEnabled,
		},
	] = useMembershipModalState();

	const prepareDLocalPermanentPaymentMethod = useDLocalPermanentPaymentMethod();

	const prepareStripePermanentPaymentMethod = useStripePermanentPaymentMethod();

	const prepareBraintreePermanentPaymentMethod = useBraintreePermanentPaymentMethod();

	return async (): Promise<void> => {
		switch (gateway) {
			case 'DLOCAL':
				if (!tokenizationData) return;
				await prepareDLocalPermanentPaymentMethod({
					...tokenizationData,
					shouldSavePaymentMethod: !usingSavedPaymentMethod,
					customer: {
						email,
					},
					usage: 'OFF_SESSION',
				});
				return;
			case 'STRIPE':
				await prepareStripePermanentPaymentMethod({
					...tokenizationData,
					paymentType,
					usage: 'OFF_SESSION',
					email,
					countryCode,
					currencyCode,
					locale,
				});
				return;
			case 'BRAINTREE':
				if (savingBraintreePaymentTemporarilyEnabled && tokenizationData?.tokenType !== 'permanent') {
					await prepareBraintreePermanentPaymentMethod({
						...tokenizationData,
						paymentType,
						usage: 'OFF_SESSION',
						email,
					});
				}
				return;
			default:
				throw new Error('Unsupported gateway');
		}
	};
}
